<template>
  <div class="list-filters" :class="{ 'is-fixed': isMapDisplayed }">
    <button type="button" class="list-filter-mobile-button list-filters-toggle">
      <IconFilter /> Filter
    </button>

    <div class="list-filters-wrap">
      <div class="list-filters-mobile-top">
        <div class="list-filters-mobile-top-heading">
          Filter <span class="list-filters-mobile-top-heading-num"></span>
        </div>
        <div class="list-filters-mobile-top-results">{{ resultsCount }} results</div>
      </div>

      <div class="list-filters-mobile-inner">
        <div class="list-filter-wrap" data-filter="school-district">
          <div class="list-filters-mobile-inner-block-heading">
            School Districts <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle">
            <span class="list-filter-toggle-text">
              School Districts <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown">
            <div
              class="list-filter-checkbox faux-checkbox-wrap"
              v-for="(district, i) in schoolDistricts"
              :key="`school-districts-${i}`"
            >
              <input
                class="faux-checkbox-input"
                type="checkbox"
                :id="`school-district_${district}`"
                :name="`school-district_${district}`"
                :value="district"
                v-model="filterSchoolDistricts"
              />
              <label
                class="list-filter-checkbox-label faux-checkbox-label"
                :for="`school-district_${district}`"
              >
                {{ district }}
              </label>
            </div>
            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear" @click="filterSchoolDistricts = []">Clear all</button>
            </div>
          </div>
        </div>

        <div class="list-filter-wrap" data-filter="property-type">
          <div class="list-filters-mobile-inner-block-heading">
            Property Type <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle">
            <span class="list-filter-toggle-text">
              Property Types <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown">
            <div
              class="list-filter-checkbox faux-checkbox-wrap"
              v-for="(propertyType, i) in propertyTypes"
              :key="`property-types-${i}`"
            >
              <input
                class="faux-checkbox-input"
                type="checkbox"
                :id="`property-type_${propertyType}`"
                name="property-type_estate"
                :value="propertyType"
                v-model="filterPropertyTypes"
              />
              <label
                class="list-filter-checkbox-label faux-checkbox-label"
                :for="`property-type_${propertyType}`"
              >
                {{ propertyType }}
              </label>
            </div>

            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear" @click="filterPropertyTypes = []">Clear all</button>
            </div>
          </div>
        </div>

        <div class="list-filter-wrap" data-filter="floorplan">
          <div class="list-filters-mobile-inner-block-heading">
            Floor Plans <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle is-small">
            <span class="list-filter-toggle-text">
              Floor Plans <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown">
            <div
              class="list-filter-checkbox faux-checkbox-wrap"
              v-for="(floorPlan, i) in floorPlans"
              :key="`floor-plans-${i}`"
            >
              <input
                class="faux-checkbox-input"
                type="checkbox"
                :id="`floorplan_${floorPlan}`"
                :name="`floorplan_${floorPlan}`"
                :value="floorPlan"
                v-model="filterFloorPlans"
              />
              <label
                class="list-filter-checkbox-label faux-checkbox-label"
                :for="`floorplan_${floorPlan}`"
              >
                {{ floorPlan }}
              </label>
            </div>

            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear" @click="filterFloorPlans = []">Clear all</button>
            </div>
          </div>
        </div>
      </div>

      <div class="list-filters-mobile-bottom">
        <button type="button" class="list-filters-mobile-bottom-clear" @click="clearAllFilters">Clear all</button>
        <button type="button" class="list-filters-mobile-bottom-done list-filters-toggle">
          Done
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import IconFilter from '@/components/icons/IconFilter';
import IconTriangleDown from '@/components/icons/IconTriangleDown';

export default {
  name: 'CommunityMapFilters',
  components: { IconFilter, IconTriangleDown },
  props: {
    floorPlans: {
      type: Array,
      required: true,
    },
    propertyTypes: {
      type: Array,
      required: true,
    },
    resultsCount: {
      type: Number,
      required: true,
    },
    schoolDistricts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    filterFloorPlans: {
      get() {
        return this.$store.getters['communities/getFilter']('floorPlans');
      },
      set(value) {
        this.$store.dispatch('communities/setFilter', { field: 'floorPlans', value });
      },
    },
    filterPropertyTypes: {
      get() {
        return this.$store.getters['communities/getFilter']('propertyTypes');
      },
      set(value) {
        this.$store.dispatch('communities/setFilter', { field: 'propertyTypes', value });
      },
    },
    filterSchoolDistricts: {
      get() {
        return this.$store.getters['communities/getFilter']('schoolDistricts');
      },
      set(value) {
        this.$store.dispatch('communities/setFilter', { field: 'schoolDistricts', value });
      },
    },
  },
  methods: {
    clearAllFilters() {
      this.$store.dispatch('communities/setFilter', { field: 'floorPlans', value: [] });
      this.$store.dispatch('communities/setFilter', { field: 'propertyTypes', value: [] });
      this.$store.dispatch('communities/setFilter', { field: 'schoolDistricts', value: [] });
    },
  },
};
</script>
